export const getMultiplierAndTimeInterval=(minutes)=>{
    const minutes_in_one_unit = {
        week: 10080,
        day: 1440,
        hour: 60
    }
    
    if(minutes >= minutes_in_one_unit['week']){
        let time_interval_multiplier = minutes / minutes_in_one_unit['week']; 
        if(Number.isInteger(time_interval_multiplier)){
            return {time_interval_multiplier, time_interval:'week'}
        }
    }

    if(minutes >= minutes_in_one_unit['day']){
        let time_interval_multiplier = minutes / minutes_in_one_unit['day']; 
        if(Number.isInteger(time_interval_multiplier)){
            return {time_interval_multiplier, time_interval:'day'}
        }
    }

    if(minutes >= minutes_in_one_unit['hour']){
        let time_interval_multiplier = minutes / minutes_in_one_unit['hour'];
        if(Number.isInteger(time_interval_multiplier)){ 
            return {time_interval_multiplier, time_interval:'hour'}
        }
    }
     
    return {time_interval_multiplier:minutes, time_interval:'minute'}
}
